import { j as t } from "./atoms-v218.js";
import { calculatedTextSkeletonHOC as l } from "./atoms-v21172.js";
import { TableHeaderCellText as a } from "./atoms-v21302.js";
function r({ label: e }) {
  return /* @__PURE__ */ t.jsx(a, { "data-testid": "calendar-table-header-cell-text", children: e.slice(0, 2) });
}
const n = l(r);
export {
  n as CalendarTableHeaderCellText
};
